<template>
	<b-modal
			id="advanced-search-modal"
			size="lg"
			style="margin: 0.5em 0 0.5em 0;"
			:visible="visible"
			@change="change"
			@ok="performSearch"
			@cancel="cancelSearch"
			@vue-tags-input-blue="testBubble"
			ok-title="Search"
			:no-close-on-esc="disableCloseOnEsc"
			@shown="modalShown"
			@hidden="modalHidden"
	>
		<template v-slot:modal-title><h4 style="color: rgb(131, 186, 35); margin-bottom: 0;">Advanced Search</h4>
		</template>
		<vue-element-loading :active="loading"></vue-element-loading>
		<!--		<FeedbackPanel></FeedbackPanel>-->
		<button class="btn btn-primary btn-sm mb-3" @click="addRequest()">Add Request</button>
		<div
				v-for="(criterion, index) in criteria"
				class="mb-2"
		>
			<search-criterion
					:tags="criterion"
					:auto-complete="fields"
					:index="index"
					@vue-tags-changed="updateCriteria"
			>
				<div class="form-check form-check-inline ml-1 mr-1"><label>Omit<input class="form-check-input ml-1"
																					  type="checkbox"
																					  v-model="omits[index]"/></label>
				</div>
				<a href="" @click.prevent="removeRequest(index)" class="vue-tags-delete pl-0">
					<!--Cancel -->
					<font-awesome-icon icon="times"></font-awesome-icon>
				</a>
			</search-criterion>

		</div>
	</b-modal>
</template>

<script>

import SearchCriterion from '../views/SearchCriterion'
import feedbackMixin from '../mixins/feedback'
import FeedbackPanel from "../components/FeedbackPanel"
import Vue from 'vue'
import {EventBus} from "../event-bus";
import $ from "jquery";

export default {
	name: "AdvancedSearch",
	mixins: [feedbackMixin],
	components: {FeedbackPanel, SearchCriterion},
	model: {
		prop: "visible",
		event: "change"
	},
	props: {
		entity: String,
		fields: Array,
		columns: Object,
		limit: Number,
		loading: Boolean,
		visible: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			criteria: [[]],
			omits: [false],
			disableCloseOnEsc: false
		}
	},
	methods: {
		escapeHandler(event) {
			console.log('Entering escape handler')
			let tagInput = $('.ti-new-tag-input');
			if (event.key === "Escape") {
				console.log("We've escaped")
				if (tagInput.is(':focus')) { // escape key maps to keycode `27`
					console.log("Click away")
					console.log(document.activeElement.tagName)
					let modal = $('.modal-content')
					modal.focus()
					console.log(document.activeElement.tagName)
					modal.click()
					console.log(document.activeElement.tagName)
				}
			}
		},
		onVueTagsInputFocus() {
			console.log('focus pocus')
			$(document).keyup(this.escapeHandler);
			this.$nextTick(() => {
				this.disableCloseOnEsc = true
			})
		},
		onVueTagsInputBlur() {
			console.log('blurry hurry')
			$(document).off('keyup')
			this.$nextTick(() => {
				this.disableCloseOnEsc = false
			})
		},
		modalHidden(event) {
			console.log('wax off')
			// $(document).off('keyup')
			EventBus.$off('search-criterion-input-blur', this.onVueTagsInputBlur)
			EventBus.$off('search-criterion-input-focus', this.onVueTagsInputFocus)
		},
		modalShown(event) {
			console.log('wax on')
			// $(document).keyup(this.escapeHandler);
			EventBus.$on('search-criterion-input-blur', this.onVueTagsInputBlur)
			EventBus.$on('search-criterion-input-focus', this.onVueTagsInputFocus)
			this.$nextTick(() => {
				this.disableCloseOnEsc = false
			})
		},
		clearSearchCriteria() {
			this.criteria = [[]];
			this.omits = [false];
			let payload = {};
			payload.searchCriteria = [];
			this.$emit('update-search-criteria', payload)
		},
		performSearch: function () {
			this.clearErrors();
			let payload = {};
			payload.advancedSearchCriteria = this.searchCriteria;
			this.$emit('advanced-search', payload)
		},
		cancelSearch: function () {
			this.clearSearchCriteria()
			this.$emit('advanced-search-cancel')
		},
		addRequest: function () {
			let request = [];
			this.criteria.push(request);
			this.omits.push(false)
		},
		removeRequest: function (index) {
			if (this.criteria.length > 1) {
				this.criteria.splice(index, 1);
				this.omits.splice(index, 1)
			} else {
				this.clearSearchCriteria()
			}
		},
		updateCriteria: function (event) {
			this.criteria.splice(event.index, 1, event.newTags)
		},
		change(visible) {
			this.$emit("change", visible)
		},
		testBubble(event) {
			console.warn(event)
		}
	},
	watch: {
		criteria(newValue, oldValue) {
			let reduction = (a, b) => {
				let bSplit = b.text.split(':');

				a[this.columns[bSplit[0]]] = bSplit[1];

				return a
			};

			let searchCriteria = newValue.map((element, index) => { //search result
				let reduced = element.reduce(reduction, {});
				Vue.set(reduced, 'omit', JSON.stringify(this.omits[index]));
				return reduced
			});
			let payload = {};
			payload.searchCriteria = searchCriteria;
			this.$emit('update-search-criteria', payload)
		},
		deep: true
	}
}
</script>

<style scoped>

</style>